/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Combobox from "@ls/react-combobox-grid";
import { useSelector } from "react-redux";
import { Cell, Grid } from "styled-css-grid";
import { selectPerfReturnValues } from "state/perfReturns/selectors";
import { summaryTypeOptionsLegacy } from "state/selections/Constants/SummaryType";

const PerfReturnSelectorComplication = ({ setDefinition, definition }) => {
  const perfReturnValues = useSelector(selectPerfReturnValues);
  const perfReturnOptions = useMemo(
    () => perfReturnValues.map((value) => ({ label: value, value })),
    [perfReturnValues]
  );

  const [setType, setSummary] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setType(value)),
      (value) => setDefinition(definition.setSummary(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell width={2}>
        <Combobox
          options={perfReturnOptions}
          onChange={setType}
          value={definition.type}
          label="Type:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell>
        <Combobox
          options={summaryTypeOptionsLegacy}
          onChange={setSummary}
          value={definition.summary}
          label="Abs/Rel:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={100}
        />
      </Cell>
    </Grid>
  );
};

PerfReturnSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(PerfReturnSelectorComplication);
